import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { SpecialUserLoginRequestSchema } from '../client-sdk/api';

export const useLoginApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createLogin = useCallback(
    async (data: SpecialUserLoginRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.specialUserLogin(data);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getSpecialUser = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        if (!query.userId || !query.userType) {
          console.error('userId or userType is missing!', {
            userId: query.userId,
            userType: query.userType,
          });
          return;
        }
        const userId = query.userId;
        const userType = query.userType;
        const response = await api.getSpecialUserDetails(userId, userType);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );
  return {
    createLogin,
    getSpecialUser,
    loading,
    error,
  };
};
